import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';
import type { TableData } from '@/types';

interface TableRowProps {
  item: TableData;
}

/**
 * Default table row component that renders a single row with its columns.
 * @param item - The table data item to render as a row.
 * @returns A table row element.
 */
const TableRow = ({ item }: TableRowProps) => {
  return (
    <Fragment>
      <tr className="bg-white border-b border-borderMedGrey">
        {item?.columns?.map((column) => {
          const { id, value, className } = column;

          return (
            <td key={id} className={twMerge('py-4 text-sm text-textDarkGrey', className)}>
              {value}
            </td>
          );
        })}
      </tr>
    </Fragment>
  );
};

export default TableRow;
